import { useQuery } from "@tanstack/react-query";
import { DELIVERABLE_CONFIGURATOR_SYNC_MEDIA_RIGHTS_QUERY_KEY } from "../constants";
import { DeliverableConfiguratorService } from "../services/deliverable.configurator.service";

export default function useGetDeliverableMediaRights() {
  const {
    data: deliverableMediaRightsData,
    isFetching: isDeliverableMediaRightsFetching,
    error: deliverableMediaRightsError,
    isSuccess: isDeliverableMediaRightsSuccess,
  } = useQuery({
    queryKey: [...DELIVERABLE_CONFIGURATOR_SYNC_MEDIA_RIGHTS_QUERY_KEY],
    queryFn: () => DeliverableConfiguratorService.getMediaRights(),
  });

  return {
    deliverableMediaRightsData,
    isDeliverableMediaRightsFetching,
    deliverableMediaRightsError,
    isDeliverableMediaRightsSuccess,
  };
}
